import { render, staticRenderFns } from "./note-form.vue?vue&type=template&id=39038c5f&"
import script from "./note-form.vue?vue&type=script&lang=js&"
export * from "./note-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports